import { render, staticRenderFns } from "./CertificationsTermsAddNew.vue?vue&type=template&id=9c5fc95c&"
import script from "./CertificationsTermsAddNew.vue?vue&type=script&lang=js&"
export * from "./CertificationsTermsAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports